import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {CookieService} from 'ngx-cookie-service';
import {WindowRef} from '../../common/window.provider';
import {IAppConfig} from "../../store/interfaces/IAppConfig";
import {SiteURLUtils} from "../../common/site.url.utils";
import {ApplicationRouteNames} from '../../common/model/application-route-names.model';

const RBF_INTERACTION_COOKIE_NAME = 'isRbf';
const FIND_HOTELS_COOKIE_NAME_PREFIX = 'selectedRate_';
const STAY_PREFERENCES_INTERACTION_PARAM = 'sp_done';
const FIND_HOTELS_INTERACTION_PARAM = 'rateSelection';
const RBF_INTERACTION_VALUE = 'true';

@Injectable()
export class RBFInteractionService {
  constructor(private _cookieService: CookieService, private  _window: WindowRef,
            private _router: Router) {}

  init()  {
    this._cookieService.set(RBF_INTERACTION_COOKIE_NAME, this._window.nativeWindow.location.protocol + '//' + this._window.nativeWindow.location.host + this._window.nativeWindow.location.pathname, 0, '/');
  }
  isFromStayPreferences(queryParams) {
    return this.hasRBFInteractionParam(queryParams, STAY_PREFERENCES_INTERACTION_PARAM);
  }
  isFromFindHotels(queryParams, reservationId, lastName) {
    return this.hasRBFInteractionParam(queryParams, FIND_HOTELS_INTERACTION_PARAM) || this.hasRBFInteractionCookie(`${FIND_HOTELS_COOKIE_NAME_PREFIX}${reservationId}`);
  }
  resetStayPreferencesInteraction(reservationId, lastName, routeName) {
    this.resetParamInteraction(reservationId, lastName, routeName);
  }
  resetFindHotelsInteraction(reservationId, lastName, routeName) {
    if (this.hasRBFInteractionCookie(`${FIND_HOTELS_COOKIE_NAME_PREFIX}${reservationId}`)) {
      this._cookieService.delete(`${FIND_HOTELS_COOKIE_NAME_PREFIX}${reservationId}`, '/');
    } else {
      this.resetParamInteraction(reservationId, lastName, routeName);
    }
  }

  resetPayInteraction(reservationId, lastName, routeName) {
    this.resetParamInteraction(reservationId, lastName, routeName);
  }

  private hasRBFInteractionCookie (cookieName: string): boolean {
    return this._cookieService.get(cookieName) === RBF_INTERACTION_VALUE;
  }

  private hasRBFInteractionParam (queryParams, paramName: string): boolean {
    return queryParams[paramName] === RBF_INTERACTION_VALUE;
  }

  private resetParamInteraction(reservationId, lastName, routeName) {
    this._router.navigate([routeName, reservationId, lastName], {queryParams: {}, replaceUrl: true});
  }

  goToPreviousPage (appConfig: IAppConfig, confirmationNumber: string, lastName: string) {
    if (this._window.nativeWindow.document.referrer) {
      if (this._window.nativeWindow.document.referrer.indexOf('/pay/confirmation') > -1) {
        SiteURLUtils.redirectToReservationConfirmation(appConfig, confirmationNumber, lastName);
      } else if (this._window.nativeWindow.document.referrer.indexOf('/account-mgmt/staydetails') > -1) {
        SiteURLUtils.redirectToStaysEvents(appConfig);
      } else {
        SiteURLUtils.redirectToReservationView(appConfig, confirmationNumber, lastName);
      }
    } else {
      SiteURLUtils.redirectToReservationView(appConfig, confirmationNumber, lastName);
    }
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/rbf-interaction.service.ts